import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

export const StyledDropdownContainer = styled.div`
    position: relative;
    margin: 12px 0 36px 0;
    & .DropdownContent-search {
        color: ${colorsPalettes.carbon[500]};
    }
`;
